import { GenericErrorBoundary } from "./GenericErrorBoundary";
import {
  BaseErrorBoundaryProps,
  RoadmapContext,
  createRoadmapState,
} from "./types";

interface Props extends BaseErrorBoundaryProps, RoadmapContext {}

export function RoadmapErrorBoundary(props: Props) {
  const { children, onError, ...contextProps } = props;

  return (
    <GenericErrorBoundary
      componentName="Roadmap"
      errorBoundaryName="RoadmapErrorBoundary"
      componentType="Roadmap"
      title="Roadmap Error"
      description="The roadmap encountered an error. Please reload the page to continue viewing your device roadmap."
      buttonText="Reload Page"
      onError={onError}
      context={contextProps}
      stateData={createRoadmapState(contextProps)}
    >
      {children}
    </GenericErrorBoundary>
  );
}
